import React, { useEffect, useRef, useState } from "react";
import { useForm, Controller, useFieldArray, useWatch } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";
import { useParams } from "react-router-dom";
import Elements from "../../components/elements/Elements";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { parsePhoneNumberFromString } from "libphonenumber-js";

// Define country-specific phone number lengths (national number, excluding country code)
const countryPhoneLengths = {
  PK: 10, // Pakistan: 10 digits
  SA: 9, // Saudi Arabia: 9 digits
  // Add more countries as needed
};

function CenterForm() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const roleId = localStorage.getItem("roleId");
  const { centerId: urlCenterId } = useParams();

  const centerId =
    urlCenterId ||
    (roleId === "3" &&
    localStorage.getItem("centerId") !== "0" &&
    localStorage.getItem("centerId") !== "null"
      ? localStorage.getItem("centerId")
      : null);

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
    getValues,
  } = useForm({
    defaultValues: {
      createdBy: localStorage.getItem("userId"),
      organizationId: localStorage.getItem("organizationId"),
      name: "",
      phoneNumber: "",
      email: "",
      // countryId: "",
      // stateId: "",
      // cityId: "",
      address: "",
      accountString: "",
      centerImage: "",
      base64String: "",
      imagePath: "",
      elements: [
        {
          name: "",
          description: "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: "",
            description: "",
            effectiveDate: "",
            endDate: "",
            createdBy: localStorage.getItem("userId"),
            fileName: "",
            filePath: "",
            base64String: "",
          },
        },
      ],
    },
  });

  const [elementsData, setElementsData] = useState([]);
  const [levelsData, setLevelsData] = useState([]);
  const [centerFileName, setCenterFileName] = useState("");
  const [previewUrl, setPreviewUrl] = useState(null);
  const [fileCounts, setFileCounts] = useState({});
  const [fileUrls, setFileUrls] = useState({});
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [isCenterDataFetched, setIsCenterDataFetched] = useState(false);

  const selectedGroups = useWatch({ control, name: "group", defaultValue: [] });
  const selectedCountry = watch("countryId");
  const selectedState = watch("stateId");
  const selectedCity = watch("cityId");

  // Fetch countries
  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await get("Dropdown/GetCountries", {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCountries(response);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };
    fetchCountries();
  }, [token]);

  // Fetch center data
  useEffect(() => {
    const fetchCenterData = async () => {
      try {
        const levelsResponse = await get(
          `Dropdown/GetAllOrganizationLevelsByOrganizationId?organizationId=${organizationId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );
        setLevelsData(levelsResponse);

        if (!centerId) return;

        const { center: singleCenterData } = await get(
          `Center/GetCenterById?centerId=${centerId}`,
          { headers: { Authorization: `Bearer ${token}` } }
        );

        if (!singleCenterData) return;

        // Country, State, and City Mapping
        // const countryId = singleCenterData?.countryId;
        // let selectedCountry = null,
        //   selectedState = null,
        //   selectedCity = null;
        // if (countryId) {
        //   selectedCountry = countries.find(
        //     (country) => country.id === countryId
        //   );
        //   const statesResponse = await get(
        //     `Dropdown/GetStates?countryId=${countryId}`,
        //     { headers: { Authorization: `Bearer ${token}` } }
        //   );
        //   setStates(statesResponse);

        //   const stateId = singleCenterData?.stateId;
        //   if (stateId) {
        //     selectedState = statesResponse.find(
        //       (state) => state.id === stateId
        //     );
        //     const citiesResponse = await get(
        //       `Dropdown/GetCities?stateId=${stateId}`,
        //       { headers: { Authorization: `Bearer ${token}` } }
        //     );
        //     setCities(citiesResponse);
        //     selectedCity = citiesResponse.find(
        //       (city) => city.id === singleCenterData.cityId
        //     );
        //   }
        // }

        // Batch File Counts and URLs
        const newFileCounts = {};
        const newFileUrls = {};

        const mappedElements =
          singleCenterData?.elementDetailsDto?.length > 0
            ? singleCenterData.elementDetailsDto.map((element, index) => {
                const matchingElement = elementsData.find(
                  (item) => item.id === element.elementId
                );

                const fileUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages/${element.filePath}`;
                newFileCounts[index] = element.fileName ? 1 : 0;
                newFileUrls[index] = fileUrl;

                return {
                  id: element.id || 0,
                  createdBy:
                    element.createdBy || localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  name: matchingElement
                    ? { value: matchingElement.id, label: matchingElement.name }
                    : null,
                  description: element.description || "",
                  elementDetail: {
                    id: element.id || 0,
                    createdBy:
                      element.createdBy || localStorage.getItem("userId"),
                    updatedBy: localStorage.getItem("userId"),
                    formId: element.formId || 0,
                    elementId: element.elementId || 0,
                    value: element.value || "",
                    description: element.description || "",
                    effectiveDate: element.effectiveDate?.split("T")[0] || null,
                    endDate: element.endDate?.split("T")[0] || null,
                    code: element.code || "",
                    fileName: element.fileName || "",
                    filePath: element.filePath || "",
                    base64String: element.base64String || "",
                  },
                  code: element.code || "",
                };
              })
            : [
                {
                  id: 0,
                  createdBy: localStorage.getItem("userId"),
                  updatedBy: localStorage.getItem("userId"),
                  name: null,
                  description: "",
                  elementDetail: {
                    id: 0,
                    createdBy: localStorage.getItem("userId"),
                    updatedBy: localStorage.getItem("userId"),
                    formId: 0,
                    elementId: 0,
                    value: "",
                    description: "",
                    effectiveDate: null,
                    endDate: null,
                    code: "",
                    fileName: "",
                    filePath: "",
                    base64String: "",
                  },
                  code: "",
                },
              ];

        setFileCounts(newFileCounts);
        setFileUrls(newFileUrls);

        const mappedLevels =
          singleCenterData.organizationLevelDetailDto?.map((level) => {
            const matchingLevel = levelsResponse.find(
              (item) => item.levelDetailId === level.id
            );
            return {
              value: matchingLevel?.levelDetailId || level.id,
              label: matchingLevel?.name || level.name,
              code: matchingLevel?.code || level.code,
            };
          }) || [];

        const accountStringFromApi = singleCenterData.accountString;
        const {
          elementDetailsDto,
          organizationLevelDetailDto,
          ...filteredSingleCenterData
        } = singleCenterData;
        const imageUrl = `${process.env.REACT_APP_LIVE_DOMAIN_URL}/ExternalImages/${singleCenterData.imagePath}`;

        setPreviewUrl(imageUrl);
        setCenterFileName(singleCenterData.centerImage);

        reset({
          ...filteredSingleCenterData,
          accountString: accountStringFromApi,
          elements: mappedElements,
          group: mappedLevels,
          id: centerId,
          base64String: "",
          updatedBy: localStorage.getItem("userId"),
          // countryId: selectedCountry
          //   ? { id: selectedCountry.id, label: selectedCountry.name }
          //   : null,
          // stateId: selectedState
          //   ? { id: selectedState.id, label: selectedState.name }
          //   : null,
          // cityId: selectedCity
          //   ? { id: selectedCity.id, label: selectedCity.name }
          //   : null,
          phoneNumber: singleCenterData.phoneNumber,
        });

        setIsCenterDataFetched(true);
      } catch (error) {
        console.error("Error fetching center data:", error);
      }
    };

    if (
      countries.length > 0 &&
      !isCenterDataFetched
      //  &&
      // elementsData.length > 0
    ) {
      fetchCenterData();
    }
  }, [
    countries,
    centerId,
    organizationId,
    elementsData,
    token,
    reset,
    setValue,
    isCenterDataFetched,
  ]);

  // Save data
  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    const elements = data.elements
      .map((element) => {
        if (!element.name || element.name.value === undefined) {
          return null;
        }
        return {
          id: element.name.value || 0,
          name: element.name?.label || element.name || "",
          description: element.description || "",
          createdBy: localStorage.getItem("userId"),
          elementDetail: {
            value: element.elementDetail?.value || "",
            description: element.elementDetail?.description || "",
            effectiveDate: element.elementDetail?.effectiveDate || null,
            endDate: element.elementDetail?.endDate || null,
            createdBy: localStorage.getItem("userId"),
            fileName: element.elementDetail?.fileName || "",
            filePath: element.elementDetail?.filePath || "",
            base64String: element.elementDetail?.base64String || "",
          },
        };
      })
      .filter((element) => element !== null);

    const formData = {
      ...data,
      elements: elements.length > 0 ? elements : null,
      centerImage: centerFileName,
      // countryId: data.countryId.value || data.countryId.id,
      // stateId: data.stateId.value || data.stateId.id,
      // cityId: data.cityId.value || data.cityId.id,
    };

    try {
      const response = await post("Center/UpdateCenter", formData, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
        if (!centerId) {
          reset();
          levelsData.forEach((_, groupIndex) => {
            setValue(`group[${groupIndex}]`, null);
          });
        }
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Rest of the existing useEffects and handlers
  useEffect(() => {
    const updatedAccountString = selectedGroups
      .map((group) => group?.code || "")
      .filter((code) => code)
      .join("-");
    setValue("accountString", updatedAccountString);
    trigger("accountString");
  }, [selectedGroups, setValue]);

  useEffect(() => {
    if (selectedCountry && selectedCountry.value) {
      const fetchStates = async () => {
        try {
          const response = await get(
            `Dropdown/GetStates?countryId=${selectedCountry.value}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setStates(response);
          setCities([]);
          setValue("stateId", null);
          setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };
      fetchStates();
    }
  }, [selectedCountry, setValue, token]);

  useEffect(() => {
    if (selectedState && selectedState.value) {
      const fetchCities = async () => {
        try {
          const response = await get(
            `Dropdown/GetCities?stateId=${selectedState.value}`,
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );
          setCities(response);
          setValue("cityId", null);
        } catch (error) {
          console.error("Error fetching cities:", error);
        }
      };
      fetchCities();
    }
  }, [selectedState, setValue, token]);

  useEffect(() => {
    const fetchElements = async () => {
      try {
        // centerId from useParams overrides localStorage if present (for editing mode)
        const effectiveCenterId = centerId || localStorage.getItem("centerId") || 0;
        const elementsResponse = await get(
          `Dropdown/GetElements?CenterId=${effectiveCenterId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setElementsData(elementsResponse);
      } catch (error) {
        console.error("Error fetching elements:", error);
      }
    };
    fetchElements();
  }, []);

  const { fields, append, remove } = useFieldArray({
    control,
    name: "elements",
  });

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setCenterFileName(file.name);
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue("base64String", base64String, { shouldValidate: true });
        setPreviewUrl(reader.result);
        trigger("centerImage");
      };
      reader.readAsDataURL(file);
    } else {
      setPreviewUrl(null);
    }
  };

  const handleAttachmentFileChange = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      setFileCounts((prevCounts) => ({ ...prevCounts, [index]: 1 }));
      setValue(`elements[${index}].elementDetail.fileName`, file.name, {
        shouldValidate: true,
      });
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result.split(",")[1];
        setValue(
          `elements[${index}].elementDetail.base64String`,
          base64String,
          { shouldValidate: true }
        );
        const fileUrl = URL.createObjectURL(file);
        setFileUrls((prevUrls) => ({ ...prevUrls, [index]: fileUrl }));
      };
      reader.readAsDataURL(file);
    } else {
      setFileCounts((prevCounts) => ({ ...prevCounts, [index]: 0 }));
      setValue(`elements[${index}].elementDetail.fileName`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.base64String`, "", {
        shouldValidate: true,
      });
      setValue(`elements[${index}].elementDetail.filePath`, "", {
        shouldValidate: true,
      });
      setFileUrls((prevUrls) => ({ ...prevUrls, [index]: "" }));
    }
  };

  const handleChangeOfInputWithLengthCheck = (fieldName) => (e) => {
    const value = e.target.value;
    setValue(fieldName, value, { shouldValidate: true });
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Center/Campus/Branch Form</h2>
      </div>
      <div className="card">
        <div className="card-body">
          <form className="row g-3" onSubmit={handleSubmit(saveData)}>
            {levelsData.length ? (
              <>
                <div className="col-12">
                  <h5 className="mb-2">
                    Levels<span className="text-danger fs-9">*</span>
                  </h5>
                  <div className="row g-2">
                    {levelsData.map((group, groupIndex) => (
                      <div className="col-2" key={groupIndex}>
                        <Controller
                          name={`group[${groupIndex}]`}
                          control={control}
                          rules={{ required: "This field is required." }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={group.map((element) => ({
                                value: element.levelDetailId,
                                label: element.name,
                                code: element.code,
                              }))}
                              onChange={(selectedOption, actionMeta) => {
                                if (actionMeta.action === "clear") {
                                  setValue(`group[${groupIndex}]`, null);
                                } else {
                                  setValue(
                                    `group[${groupIndex}]`,
                                    selectedOption || {
                                      value: 0,
                                      label: "",
                                      code: "",
                                    }
                                  );
                                }
                                trigger(`group[${groupIndex}]`);
                              }}
                              className="react-select-style"
                              classNamePrefix="react-select-style-pref"
                              isClearable
                            />
                          )}
                        />
                        {errors.group?.[groupIndex] && (
                          <small className="text-danger">
                            {errors.group[groupIndex].message}
                          </small>
                        )}
                      </div>
                    ))}
                    <div className="col-md-12 mt-3 d-none">
                      <label className="form-label">
                        Account String
                        <span className="text-danger fs-9">*</span>
                      </label>
                      <input
                        {...register("accountString", {
                          required: "This field is required.",
                        })}
                        type="text"
                        className="form-control"
                        placeholder=""
                        disabled={true}
                      />
                      {errors.accountString && (
                        <small className="text-danger">
                          {errors.accountString.message}
                        </small>
                      )}
                    </div>
                  </div>
                </div>
                <div className="col-12">
                  <hr className="mt-1 mb-0" />
                </div>
              </>
            ) : (
              <small className="text-danger">Please create levels first.</small>
            )}

            <div className="col-12">
              <div className="row g-3 justify-content-center">
                <div className="col-md-3">
                  <div className="image-uploader-wrapper d-flex flex-column align-items-center">
                    <div className="image-preview d-flex justify-content-center align-items-center mb-3">
                      {previewUrl ? (
                        <img src={previewUrl} alt="Preview" />
                      ) : (
                        <div>
                          <span className="fas fa-image fs-3 text-light"></span>
                        </div>
                      )}
                    </div>
                    <label className="form-label">
                      Center / Campus / Branch Picture
                    </label>
                    <input
                      {...register("centerImage")}
                      type="file"
                      className="form-control"
                      accept="image/*"
                      onChange={handleFileChange}
                    />
                  </div>
                  {errors.centerImage && (
                    <small className="text-danger">
                      {errors.centerImage.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <div className="col-12">
              <div className="row g-3">
                <div className="col-md-3">
                  <label className="form-label">
                    Name<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("name", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("name")}
                  />
                  {errors.name && (
                    <small className="text-danger">{errors.name.message}</small>
                  )}
                </div>

                {/* Fixed Phone Number Field */}
                <div className="col-md-3">
                  <label className="form-label">
                    Mobile No.
                    <span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="phoneNumber"
                    control={control}
                    rules={{
                      required: "Phone number is required",
                      validate: (value) => {
                        if (!value) return "Phone number is required";
                        const parsed = parsePhoneNumberFromString(value);
                        if (!parsed || !parsed.isValid()) {
                          return "Invalid phone number";
                        }
                        const countryCode = parsed.country;
                        const nationalNumber = parsed.nationalNumber;
                        const maxLength = countryPhoneLengths[countryCode];
                        if (maxLength && nationalNumber.length !== maxLength) {
                          return `Phone number must be exactly ${maxLength} digits for ${countryCode}`;
                        }
                        // Strict validation for maximum 12 digits
                        const totalDigits = value.replace(/[^0-9]/g, "").length;
                        if (totalDigits > 12) {
                          return "Phone number cannot exceed 12 digits";
                        }
                        return true;
                      },
                    }}
                    render={({ field: { onChange, value } }) => (
                      <PhoneInput
                        value={value}
                        onChange={(newValue) => {
                          // Restrict input to 12 digits during typing
                          const digitCount = (newValue || "").replace(
                            /[^0-9]/g,
                            ""
                          ).length;
                          if (!newValue || digitCount <= 12) {
                            onChange(newValue);
                          }
                        }}
                        defaultCountry="PK" // Set Saudi Arabia as the default country
                        international // Show international format with country code
                        countryCallingCodeEditable={false} // Prevent editing the country code
                        className="custom-phone-input" // Custom class for styling consistency
                        placeholder="Enter phone number"
                        // Add maxLength to the underlying input for extra safety
                        inputProps={{
                          maxLength: 16, // Approximate max length to account for formatting (+, spaces)
                        }}
                        onKeyDown={(e) => {
                          // Prevent typing if digit count would exceed 12
                          const inputValue = e.target.value || "";
                          const digitCount = inputValue.replace(
                            /[^0-9]/g,
                            ""
                          ).length;
                          if (
                            digitCount >= 12 &&
                            e.key !== "Backspace" &&
                            e.key !== "Delete" &&
                            e.key !== "ArrowLeft" &&
                            e.key !== "ArrowRight" &&
                            e.key !== "Tab"
                          ) {
                            e.preventDefault();
                          }
                        }}
                        onPaste={(e) => {
                          // Prevent pasting if the resulting digits would exceed 12
                          const pastedData = e.clipboardData.getData("text");
                          const newDigitCount = (value + pastedData).replace(
                            /[^0-9]/g,
                            ""
                          ).length;
                          if (newDigitCount > 12) {
                            e.preventDefault();
                          }
                        }}
                      />
                    )}
                  />
                  {errors.phoneNumber && (
                    <small className="text-danger">
                      {errors.phoneNumber.message}
                    </small>
                  )}
                </div>

                <div className="col-md-3">
                  <label className="form-label">
                    Email Address<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("email", {
                      required: "This field is required.",
                      maxLength: {
                        value: 75,
                        message: "Maximum of 75 characters allowed.",
                      },
                      pattern: {
                        value:
                          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                        message: "Please enter a valid email.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("email")}
                  />
                  {errors.email && (
                    <small className="text-danger">
                      {errors.email.message}
                    </small>
                  )}
                </div>

                {/* <div className="w-100 m-0"></div> */}

                <div className="col-md-3 d-none">
                  <label className="form-label">
                    Country<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="countryId"
                    control={control}
                    // rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={countries.map((country) => ({
                          value: country.id,
                          label: country.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("countryId", null);
                          } else {
                            setValue(
                              "countryId",
                              selectedOption || {
                                value: 0,
                                label: "",
                              }
                            );
                          }
                          trigger("countryId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.countryId && (
                    <small className="text-danger">
                      {errors.countryId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-3 d-none">
                  <label className="form-label">
                    State<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="stateId"
                    control={control}
                    // rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={states.map((state) => ({
                          value: state.id,
                          label: state.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("stateId", null);
                          } else {
                            setValue(
                              "stateId",
                              selectedOption || {
                                value: 0,
                                label: "",
                              }
                            );
                          }
                          trigger("stateId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.stateId && (
                    <small className="text-danger">
                      {errors.stateId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-3 d-none">
                  <label className="form-label">
                    City<span className="text-danger fs-9">*</span>
                  </label>
                  <Controller
                    name="cityId"
                    control={control}
                    // rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={cities.map((city) => ({
                          value: city.id,
                          label: city.name,
                        }))}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue("cityId", null);
                          } else {
                            setValue(
                              "cityId",
                              selectedOption || {
                                value: 0,
                                label: "",
                              }
                            );
                          }
                          trigger("cityId");
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                      />
                    )}
                  />
                  {errors.cityId && (
                    <small className="text-danger">
                      {errors.cityId.message}
                    </small>
                  )}
                </div>

                <div className="col-md-3">
                  <label className="form-label">
                    Address<span className="text-danger fs-9">*</span>
                  </label>
                  <input
                    {...register("address", {
                      required: "This field is required.",
                      maxLength: {
                        value: 250,
                        message: "Maximum of 250 characters allowed.",
                      },
                    })}
                    type="text"
                    className="form-control"
                    placeholder=""
                    onChange={handleChangeOfInputWithLengthCheck("address")}
                  />
                  {errors.address && (
                    <small className="text-danger">
                      {errors.address.message}
                    </small>
                  )}
                </div>
              </div>
            </div>

            <Elements
              fields={fields}
              control={control}
              register={register}
              errors={errors}
              watch={watch}
              elementsData={elementsData}
              append={append}
              remove={remove}
              handleAttachmentFileChange={handleAttachmentFileChange}
              fileCounts={fileCounts}
              fileUrls={fileUrls}
              setValue={setValue}
              getValues={getValues}
              trigger={trigger}
            />

            {roleId !== "3" && (
              <div className="col-12">
                <button
                  className="btn btn-primary btn-sm"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? "Saving..." : "Save"}
                </button>
              </div>
            )}
          </form>
        </div>
      </div>
    </>
  );
}

export default CenterForm;
